import validation from '../../../../../../modules/Gull/Framework/validation.js';

const werkgeverSalaris = {

	init() {

		// Toon en verberg aanvullende salarisvelden bij oproepbasis
		$('#oproepBasis').change(function() {
			// Verberg alle salarisvelden
			$('.form-section-salaris-a, .form-section-salaris-b-c ').addClass('d-none').find('input,select').not('.file-caption-name').each(function(i, e) {
				validation.removeRequired(e);
			});
			if ($(this).val() == 'ja') {
				// Toon alle salaris velden
				$('.form-section-salaris-a, .form-section-salaris-b-c ').removeClass('d-none').find('input,select').not('.file-caption-name').each(function(i, e) {
					validation.addRequired(e);
				});
				// $('#salarisstrookUploadA,#salarisstrookUploadB,#salarisstrookUploadC').each(function(i,e) {
				// 	validation.removeRequired(e);
				// });
			} else {
				// Toon alleen de laatste salaris velden
				$('.form-section-salaris-a').removeClass('d-none').find('input,select').not('.file-caption-name').each(function(i, e) {
					validation.addRequired(e);
				});
			}
		});
		$('#oproepBasis').trigger('change');

		// Submit
		$('form[data-validate]').attr('data-validate-onsubmit-disabled', true);
		$('form[data-validate]').submit(async function() {
			let validated = await validation.checkSubmitForm(this);
			if (validated) {
				$('#loadingModal').modal('show', {
					backdrop: 'static',
					keyboard: false
				});
				setTimeout(function() {
					$('form[data-validate]').unbind('submit');
					$('form[data-validate]').submit();
				}, 1000);
				//
			}
			return false;
		});

	}

};

export default werkgeverSalaris;
